import React, { useEffect, useState } from 'react';
import { useOCPStore } from '../hooks/useOCPStore';
import { useDraftFlowStore } from '../hooks/useDraftFlowStore';
import { Icon, TextField, Typography } from '@scale/scaleui';

const FlowName: React.FC = () => {
  const {
    currentFlow,
    currentVersion,
    setCurrentVersion,
    autofocusFlowName,
    toggleAutofocusFlowName,
  } = useOCPStore(state => ({
    currentFlow: state.currentFlow,
    currentVersion: state.currentVersion,
    setCurrentVersion: state.setCurrentVersion,
    autofocusFlowName: state.autofocusFlowName,
    toggleAutofocusFlowName: state.toggleAutofocusFlowName,
  }));
  const { draftFlows, editFlowName } = useDraftFlowStore(state => ({
    draftFlows: state.draftFlows,
    editFlowName: state.editFlowName,
  }));
  const [flowNameEditMode, setFlowNameEditMode] = useState<boolean>(false);
  const [flowName, setFlowName] = useState<string>(
    currentVersion === -1 ? draftFlows[currentFlow?._id ?? '']?.name : currentFlow?.name ?? '',
  );

  useEffect(() => {
    if (currentFlow?.name) setFlowName(currentFlow.name);
  }, [currentFlow?.name]);

  useEffect(() => {
    if (autofocusFlowName) setFlowNameEditMode(true);
  }, [autofocusFlowName]);

  const handleStartEdit = () => {
    setFlowNameEditMode(true);
    if (currentVersion !== -1) setCurrentVersion(-1);
  };

  const confirmEditFlowName = () => {
    setFlowNameEditMode(false);
    if (currentFlow && draftFlows[currentFlow._id].name !== flowName)
      editFlowName(currentFlow?._id, flowName);
    toggleAutofocusFlowName(false);
  };

  const displayName =
    currentVersion === -1 ? draftFlows[currentFlow?._id ?? '']?.name : currentFlow?.name;

  return (
    <div className="flex gap-1 items-center">
      {flowNameEditMode && currentFlow ? (
        <TextField
          id="flow-name"
          className="w-80"
          value={flowName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFlowName(e.target.value)}
          onKeyPress={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              confirmEditFlowName();
            }
          }}
          autoFocus={autofocusFlowName}
        />
      ) : (
        <Typography.H3 className={displayName ? '' : 'mt-2 mb-3 mr-2'}>
          {displayName ?? 'Onboarding Control Panel'}
        </Typography.H3>
      )}
      {!flowNameEditMode && currentFlow && (
        <Icon rounded variant="neutral" icon="pencil" onClick={handleStartEdit} />
      )}
      {flowNameEditMode && (
        <Icon rounded variant="neutral" icon="check" onClick={() => confirmEditFlowName()} />
      )}
    </div>
  );
};

export default FlowName;
